import { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import Icon from '../../atoms/Icon';

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 25px;
`;

const Controls = styled.button`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &:hover {
    svg {
      color: ${(props) => props.theme.color.cta};
    }
  }
`;

const Label = styled.span`
  color: ${(props) => props.theme.color.primary800};
  transition: color 0.25s ease-out;
  margin: 0 0 0 10px;

  &:hover {
    color: ${(props) => props.theme.color.cta};
  }
`;

const StyledIcon = styled(Icon)`
  color: ${(props) => props.theme.color.primary800};
  height: 15px;
  width: 13px;
  transform: ${(props) =>
    props.isActive ? 'rotate(-90deg)' : 'rotate(90deg)'};
`;

/**
 * @param {DisplayToggleWrapperProps} props
 * @returns {React.ReactElement} The rendered component
 */
const DisplayToggleWrapper = ({
  label,
  initialActiveState,
  children,
  currentActiveState,
}) => {
  const [isActive, toggleActiveState] = useState(initialActiveState);
  const mapId = 'jobAdsMap';
  const handleToggle = () => {
    toggleActiveState(!isActive);
    if (currentActiveState) return currentActiveState(!isActive);
    return false;
  };

  return (
    <Wrapper>
      <Link
        to={!isActive ? mapId : ''}
        smooth={true}
        duration={800}
        delay={500}
      >
        <Controls type="button" onClick={() => handleToggle()}>
          <StyledIcon icon="ARROW_BOLD" isActive={isActive} />
          {label && <Label>{label}</Label>}
        </Controls>
      </Link>
      <div id={mapId} />
      {isActive && children}
    </Wrapper>
  );
};

export default DisplayToggleWrapper;
